import React from 'react';
import { Star, ArrowRight } from 'lucide-react';
const testimonials = [{
  name: 'Lic. Mariana Varela',
  city: 'CABA',
  text: 'Excelente material. Me dio la estructura que me faltaba para ordenar la evaluación. Las herramientas de regulación emocional son muy prácticas para usar en sesión.'
}, {
  name: 'Lic. Sofía Bernardi',
  city: 'Córdoba',
  text: 'Muy claro y directo al punto. El módulo de perfeccionismo y sobreexigencia me ayudó a destrabar a varios pacientes que venían estancados. Lo recomiendo.'
}, {
  name: "Lic. Florencia D'Agostino",
  city: 'Rosario',
  text: 'El diagnóstico diferencial es una joya. Siempre tuve dudas con el solapamiento con TDAH y este kit me aclaró muchísimo el panorama. Muy completo.'
}, {
  name: 'Lic. Camila Rinaldi',
  city: 'Mendoza',
  text: 'Las plantillas y los bonus son súper útiles. Ya estoy usando la guía de psicoeducación con mis pacientes y les encanta porque se sienten comprendidos.'
}, {
  name: 'Lic. Julieta Pizarro',
  city: 'La Plata',
  text: 'Me sorprendió la calidad clínica del material. No es teoría vacía, son intervenciones concretas que podés aplicar al día siguiente en el consultorio.'
}];
export function Testimonials() {
  return <div className="py-16 bg-slate-50" data-id="element-299">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-300">
        <h2 className="text-3xl font-bold text-center text-slate-900 mb-12" data-id="element-301">
          Lo que dicen otros profesionales
        </h2>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-302">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex flex-col h-full" data-id="element-303">
              <div className="flex gap-1 mb-4" data-id="element-304">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-305" />)}
              </div>
              <p className="text-slate-600 italic mb-6 flex-grow" data-id="element-306">"{t.text}"</p>
              <div data-id="element-307">
                <p className="font-bold text-slate-900" data-id="element-308">{t.name}</p>
                <p className="text-sm text-slate-500" data-id="element-309">{t.city}</p>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-310">
          <button type="button" onClick={() => {
          const target = document.getElementById('compra');
          const top = target ? target.getBoundingClientRect().top + window.scrollY : 0;
          try {
            window.scrollTo({
              top,
              behavior: 'smooth'
            });
          } catch {
            window.scrollTo(0, top);
          }
        }} className="inline-flex items-center justify-center gap-2 w-full sm:w-auto bg-amber-500 hover:bg-amber-400 text-amber-950 font-bold text-xl md:text-2xl px-10 py-5 rounded-xl shadow-[0_0_40px_rgba(245,158,11,0.3)] hover:shadow-[0_0_60px_rgba(245,158,11,0.5)] transition-all transform hover:-translate-y-1" data-id="element-311">
            SÍ, QUIERO EL KIT AHORA
            <ArrowRight className="w-5 h-5" data-id="element-312" />
          </button>

          {/* Final professional disclaimer */}
          <div className="mt-16 max-w-2xl mx-auto text-left bg-white border border-slate-200 rounded-2xl p-6" data-id="element-313">
            <p className="font-bold text-slate-800 mb-2" data-id="element-314">
              ACLARACIÓN PROFESIONAL
            </p>
            <p className="text-slate-600 text-sm leading-relaxed" data-id="element-315">
              Este material está dirigido a profesionales de la salud mental. No
              reemplaza evaluación psicológica clínica, neuropsicológica,
              psicométrica, psiquiátrica, médica, psicopedagógica ni supervisión
              profesional cuando corresponda.
            </p>
          </div>
        </div>
      </div>
    </div>;
}